import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { WalletService } from '../../../shared/services/apis/platform/wallet.service';
import { WalletWithdrawalRequest } from '../../../shared/services/requests/platform/wallet-withdrawal.request';
import { ReturnStruct } from '../../../shared/services/structs/return.struct';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface WithdrawalDialogData {
    availableForWithdrawal: number;
    minWithdrawalAmount: number;
    defaultPix?: string;
}

@Component({
    selector: 'app-withdrawal-request-modal',
    templateUrl: 'withdrawal-request-modal.component.html',
    styleUrls: ['withdrawal-request-modal.component.css'],
    imports: [CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        MatOptionModule,
        MatRadioModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatButtonModule,
        MatCheckboxModule,
        MatSelectModule],
})
export class WithdrawalRequestModalComponent {
    pix: string = '';
    isLoading = false;
    errorMsg = '';

    constructor(
        private dialogRef: MatDialogRef<WithdrawalRequestModalComponent>,
        private walletSvc: WalletService,
        @Inject(MAT_DIALOG_DATA) public data: WithdrawalDialogData,
    ) {
        if (data?.defaultPix) this.pix = data.defaultPix;
    }

    formatBRL(v?: number | null): string {
        const n = typeof v === 'number' ? v : 0;
        return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    canConfirm(): boolean {
        if (this.isLoading) return false;
        if (!this.pix || this.pix.trim().length < 3) return false;
        if (this.data.availableForWithdrawal < this.data.minWithdrawalAmount) return false;
        return true;
    }

    save(): void {
        if (!this.canConfirm()) return;
        this.isLoading = true;
        this.errorMsg = '';

        const req: WalletWithdrawalRequest = { pix: this.pix.trim() };

        this.walletSvc.requestWithdrawal(req).subscribe({
            next: (res: ReturnStruct) => {
                this.isLoading = false;
                if (res.isError) {
                    this.errorMsg = res.errorDescription || 'Falha ao solicitar retirada.';
                    return;
                }
                this.dialogRef.close(true); // sucesso
            },
            error: () => {
                this.isLoading = false;
                this.errorMsg = 'Falha ao solicitar retirada.';
            }
        });
    }

    close(): void {
        this.dialogRef.close(false);
    }
}
